<section class="b2b-form" id="formulario-b2b">
    <h2 class="b2b-form--title">Descubra quanto sua empresa pode economizar.</h2>
    <p class="b2b-form--subtitle">
        Solicite uma análise e receba uma recomendação personalizada para o seu negócio.
    </p>

    <div class="b2b-form__card">
        <form action="#" autocomplete="off" [formGroup]="form" (ngSubmit)="onSubmit()">
            <app-input
                [type]="'revenda'"
                id="b2b-name"
                name="name"
                labelName="Nome Completo"
                placeholder="Ex: João Silva"
                [form]="form"
                [required]="true"
            ></app-input>

            <app-input
                [type]="'revenda'"
                id="b2b-company"
                name="company"
                labelName="Empresa (Razão Social/Nome Fantasia)"
                placeholder="Ex: Everest LTDA"
                [form]="form"
                [required]="true"
            ></app-input>

            <div class="b2b-form__card--row">
                <app-input
                    [type]="'revenda'"
                    id="b2b-city"
                    name="city"
                    labelName="Cidade"
                    placeholder="Ex: Rio de Janeiro"
                    [form]="form"
                    [required]="true"
                    style="width: 100%;"
                ></app-input>

                <app-input
                    [type]="'revenda'"
                    id="b2b-state"
                    name="state"
                    labelName="Estado"
                    placeholder="Ex: RJ"
                    [form]="form"
                    [required]="true"
                    style="width: 100%;"
                ></app-input>
            </div>

            <app-input
                [type]="'revenda'"
                id="b2b-email"
                name="email"
                typeInput="email"
                labelName="E-mail Corporativo"
                placeholder="exemplo@empresa.com.br"
                [form]="form"
                [required]="true"
            ></app-input>

            <app-input
                [type]="'revenda'"
                id="b2b-phone"
                name="phone"
                labelName="Telefone com DDD"
                placeholder="(11) 99999-9999"
                [inputMask]="'(00) 00000-0000'"
                [form]="form"
                [required]="true"
            ></app-input>

            <app-select
                [type]="'contact'"
                id="b2b-employees_number"
                name="employees_number"
                labelName="Nº de Colaboradores"
                placeholder="Selecione uma opção"
                [options]="employeesOptions"
                [form]="form"
                [required]="true"
            ></app-select>

            <app-text-area
                id="b2b-message"
                name="message"
                labelName="Observações"
                placeholder="Escreva aqui"
                [form]="form"
                [required]="true"
            ></app-text-area>

            <p class="b2b-form__card--helper">
                Nossa equipe entrará em contato para entender sua operação e indicar a melhor solução.
            </p>

            <button type="submit" class="b2b-form__card--button" [disabled]="submitting">
                {{ submitting ? 'Enviando...' : 'Solicitar análise' }}
            </button>
        </form>
    </div>
</section>
